import { createGlobalStyle } from "styled-components";
import "./../../colors.css";

export const GlobalStyles = createGlobalStyle`
  body,.splitpane__divider, .esri-elevation-profile-legend-item__header, .esri-elevation-profile-legend-item__content,
  .esri-elevation-profile__header button:hover, .esri-button--tertiary:hover, .selectionLayer, #selectData,#remove-selectData,
 .appbar__toggle__box--middle--top--selected,
  .appbar__toggle__box--middle--bottom--selected, .esri-elevation-profile-settings__popover-content,
   .esri-elevation-profile-settings__select, .size-error , .survey, 
   .css-t3ipsp-control, .css-1dimb5e-singleValue,.esri-layer-list__no-items, .inputfield 
  {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }
  //MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-ptiqhd-MuiSvgIcon-root
  //MuiTypography-root MuiTypography-h6 MuiDialogTitle-root css-bdhsul-MuiTypography-root-MuiDialogTitle-root
  //MuiTypography-root MuiDialogContentText-root MuiTypography-body1 MuiDialogContentText-root css-qfso29-MuiTypography-root-MuiDialogContentText-root
  // .MuiPaper-root, .MuiPaper-elevation, .MuiPaper-rounded, .MuiPaper-elevation1, .css-jkymtx-MuiPaper-root
  .MuiPaper-root{
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text4};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .cr_edit_step{
    color: ${({ theme }) => theme.text2};
  }

  .cr_edit_ToolTitle{
    color: ${({ theme }) => theme.text6};
  }

  //MuiInputBase-input MuiOutlinedInput-input css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input
  .cr_edit_icons{
    color: ${({ theme }) => theme.text};
  }

  .cr_batchedit_icons{
    color: ${({ theme }) => theme.text2};
  }

  .MuiDialogContentText-root{
    color: ${({ theme }) => theme.text};
  }

  //MuiListItemIcon-root css-cveggr-MuiListItemIcon-root
 
  .navbar
  {
    background: ${({ theme }) => theme.main};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .timelines-chart .axises .grp-axis text{
    fill: #14976b
  }

  .timelines-chart .axises .y-axis text{
    fill: #14976b
  }
  .css-13cymwt-control, .css-1nmdiq5-menu{
    background: ${({ theme }) => theme.body};
    color: #4DB970
  }

  #queryDiv{
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .splitpane-button
  {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }


  .select, .select--outline, .select--full{
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text6};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .fieldButton, .cancelButton{
    background: ${({ theme }) => theme.body};
  }

  .css-1nmdiq5-menu:hover {
    color: rgb(94, 91, 91);
  }
  
  // .splitpane__divider__handle--hor
  // {
  //   border-bottom: 1px solid #00001A;
  // }

  .appbar__toggle--left, .appbar__toggle--right,.appbar__toggle__box--middle--left--selected,
   .appbar__toggle__box--middle--right--selected,{
    background: ${({ theme }) => theme.body9};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .table__head, .esri-elevation-profile, input#ContactName.css-1vn5f2f, input#ContactEmail.css-1vn5f2f,
   textarea#Content.css-1cwhvud, .esri-bookmarks__add-bookmark, .esri-widget__table tr:nth-child(odd), .clearOverlays, .selectOverlays{
    background:${({ theme }) => theme.body5};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }


  .table__row:nth-of-type(even) td {
    background:${({ theme }) => theme.body5};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }
 
  .table__row--selected td {
    background-color: ##7ac492 !important;
  }
  .table__row:hover td {
    background-color: #4db970;
  }

   .parcel, .esri-layer-list__item, .esri-layer-list-panel, .esri-legend, .esri-slider, .selectionBox, 
   .esri-layer-list__item-actions-menu-item:hover, .esri-layer-list__item-actions-menu-item,
   .esri-bookmarks_bookmark-drag-handle, .esri-bookmarks__bookmark,
   .esri-bookmarks__bookmark-button, .esri-bookmarks__authoring-form, .esri-popup__header-title, .esri-button-menu__content,
   .esri-button-menu__item .esri-button-menu__item-label, .esri-button-menu .esri-button-menu__button,
   .esri-layer-list__child-toggle, .esri-bookmarks__bookmark-edit-button, .selectData,
   .esri-measurement, #infoDiv, .esri-print__container, h3.esri-widget__heading,
   .esri-print,  #bufferInput, .esri-widget__heading, .esri-widget__heading.esri-feature-element-info__title, 
   .esri-widget__table, .esri-feature__content-element, .esri-feature, .parcelSelection,
   .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root
   {
    background: ${({ theme }) => theme.body4};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

   .clearData, #remove-selectData.removeSelectData,.AddSelectionData{
    background: ${({ theme }) => theme.body4};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }
  

  .esri-layer-list__item-toggle
  {  
   color: ${({ theme }) => theme.text4};
   transition: background 0.2s ease-in, color 0.2s ease-in;
 }

  .drawercont,fieldset.css-dyzsxa-Form , .esri-bookmarks__bookmark *:hover,
  .esri-bookmarks__bookmark-label:hover, .esri-bookmarks__authoring-card,
  .esri-button-menu__item .esri-button-menu__item-label:hover  {
    background:${({ theme }) => theme.body5};
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .esri-basemap-gallery__item-title{
    color: ${({ theme }) => theme.body8};
  }

  .esri-basemap-gallery__item-title:hover{  
    color: ${({ theme }) => theme.text1};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .esri-bookmarks__bookmark-name{    
    color: ${({ theme }) => theme.text};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .esri-bookmarks__authoring-actions .esri-bookmarks__authoring-delete-button{
    background:${({ theme }) => theme.body4};
    color: ${({ theme }) => theme.text1};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }


  .esri-layer-list__item--invisible-at-scale .esri-layer-list__item-title{
    background:${({ theme }) => theme.body4};
    color: ${({ theme }) => theme.text2};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .esri-button--tertiary{
    color: ${({ theme }) => theme.text3};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }


  .scroll::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #fff;
    background: ${({ theme }) => theme.body2};
    color: ${({ theme }) => theme.text5};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }

  .MuiDataGrid-virtualScroller::-webkit-scrollbar-track{
    background-color: ${({ theme }) => theme.body2};
  }

  .scroll--alt::-webkit-scrollbar-track-piece:end {
    border-radius: 10px;
    margin-bottom: 2rem;
    background-color: #F4F5FC;
    background: ${({ theme }) => theme.body2};
    color: ${({ theme }) => theme.text5};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }
  .scroll--alt::-webkit-scrollbar-track-piece:start {
    border-radius: 10px;
    margin-top: 2.5rem;
    background-color: #F4F5FC;
    background: ${({ theme }) => theme.body2};
    color: ${({ theme }) => theme.text5};
    transition: background 0.2s ease-in, color 0.2s ease-in;
  }
  .MuiCheckbox-root,.MuiSelect-select, .MuiSelect-icon, .MuiFormLabel-root,
  .MuiIconButton-root{
    color:${({ theme }) => theme.text}
  }
  .MuiButtonBase-root.MuiButton-root.Mui-disabled{
  background-color:#F4F5FC;
}
.MuiInputBase-root.MuiInput-root{
  color:${({ theme }) => theme.text}
}
.table__cell,.table__head__cell{
  color:${({ theme }) => theme.text}
}
.MuiTablePagination-root{
  background-color:${({ theme }) => theme.filterFormBackgroundColor}
}
.MuiDataGrid-cellContent,.MuiDataGrid-columnHeaderTitle,
.MuiDataGrid-selectedRowCount,
.MuiTablePagination-selectLabel,
.MuiTablePagination-displayedRows{
  color:${({ theme }) => theme.text}
}
.MuiDataGrid-filterForm,
.MuiNativeSelect-select.MuiNativeSelect-standard.MuiInputBase-input.MuiInput-input option:not(:checked),
.MuiNativeSelect-select.MuiNativeSelect-standard.MuiInputBase-input.MuiInput-input option:checked{
  background-color:${({ theme }) => theme.filterFormBackgroundColor};
}
.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiNativeSelect-icon.MuiNativeSelect-iconStandard{
  color:${({ theme }) => theme.text}
}
.MuiDataGrid-virtualScrollerRenderZone .MuiDataGrid-row:nth-child(odd) {
  background-color: ${({ theme }) => theme.oddRowBackgroundColor};
  /* Adjust styles as needed */
}
.MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-colorPrimary.MuiInputBase-formControl:before,
.MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-colorPrimary:before {
  border-bottom-color:${({ theme }) => theme.text}
} 
.MuiInputBase-input.MuiOutlinedInput-input{
  color:${({ theme }) => theme.text}
}
.MuiTab-textColorPrimary{
  color:${({ theme }) => theme.text}
}
`;

export const lightTheme = {
  body: "#f1f1f1",
  text: "#121620",
  main: "#14976b",
  filterFormBackgroundColor: "#ffffff",
  oddRowBackgroundColor: "#dbf8e5",
};

export const darkTheme = {
  main: "#070D0A",
  body1: "#29293d",
  //body: "#33334d",
  body: "#002717",
  body2: "#00001a",
  body3: "#1f1f2e",
  //body4: "#33334d",
  body4: "#002717",
  body5: "#0B1A13",
  body6: "#8c2907",
  body7: "#4db970",
  body8: "#dbf8e5",
  body9: "#555867",
  body10: "00160D",
  text4: "#14976b",
  text: "#f1f1f1",
  text1: "#ef4207",
  text2: "#a8a8a8",
  text3: "#89CFF0",
  text5: "#FFFFFF",
  text6: "#fe805c",
  filterFormBackgroundColor: "#0e6347",
  oddRowBackgroundColor: "#0b1a13",
};
